export enum ClientStatusEnum {
    ENABLED = 'ENABLED',
    DISBALED = 'DISABLED',
}
